export const explorerUrl = 'https://content.nintondo.io/api/pub/content/'